// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
// } from "@mui/material";
// import { toast } from "react-toastify";

// export default function AskFirmNameDialog({ open, onClose, onConfirm }) {
//   const [firmName, setFirmName] = useState("");

//   const errorTost = (msg) => {
//     toast.error(msg, {
//       position: "top-right",
//       autoClose: 3000,
//     });
//   };

//   const handleSave = () => {
//     const trimmedName = firmName.trim();
//     if (trimmedName === "") {
//       errorTost("Please enter a valid firm name.");
//       return;
//     }
//     onConfirm(trimmedName);
//     setFirmName("");
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           px: 3,
//           py: 2,
//           borderRadius: 2,
//           minWidth: { xs: "85vw", sm: "500px" }, // Slightly larger on mobile
//         },
//       }}
//     >
//       <DialogTitle
//         sx={{
//           fontSize: { xs: "1.9rem", sm: "1.5rem" },
//           fontWeight: 600,
//         }}
//       >
//      PAN And RERA Name Mismatch Please Enter Proprietorship / Firm Name
//       </DialogTitle>

//       <DialogContent>
//         <TextField
//           autoFocus
//           margin="dense"
//           label="Firm Name"
//           // placeholder="Pan And Rera name mismatch please Enter Proprietorship / Firm Name"
//           fullWidth
//           value={firmName}
//           onChange={(e) => setFirmName(e.target.value)}
//           sx={{
//             "& .MuiInputBase-input": {
//               fontSize: { xs: "2rem", sm: "1.1rem" },
//             },
//             "& .MuiInputLabel-root": {
//               fontSize: { xs: "2rem", sm: "1.05rem" },
//             },
//           }}
//         />
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 2 }}>
//         <Button onClick={onClose} sx={{ fontSize: { xs: "1.8rem", sm: "1rem" } }}>
//           Cancel
//         </Button>
//         <Button
//           variant="contained"
//           onClick={handleSave}
//           sx={{ fontSize: { xs: "1.8rem", sm: "1rem" } }}
//         >
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }



import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import { supabase } from "../../supabaseClient"; // Adjust path to your config

export default function AskFirmNameDialog({ open, onClose, onConfirm }) {
  const [firmName, setFirmName] = useState("");
  const [shopActFile, setShopActFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const errorTost = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 3000,
    });
  };

  // const handleSave = async () => {
  //   const trimmedName = firmName.trim();

  //   if (trimmedName === "") {
  //     errorTost("Please enter a valid firm name.");
  //     return;
  //   }

  //   if (!shopActFile) {
  //     errorTost("Please select the Shop Act document.");
  //     return;
  //   }

  //   setIsUploading(true);

  //   try {
  //     // Store file inside the cpshopact folder of the kycdocuments bucket
  //     const fileName = `${Date.now()}_${shopActFile.name}`;
  //     const filePath = `cpshopact/${fileName}`;

  //     const { error: uploadError } = await supabase.storage
  //       .from("kycdocuments") // Your bucket name
  //       .upload(filePath, shopActFile, {
  //         cacheControl: "3600",
  //         upsert: false,
  //       });

  //     if (uploadError) throw uploadError;

  //     // Build the public URL using your Supabase project URL
  //     const bucketPrefix = process.env.REACT_APP_SUPABASE_BUCKET_PREFIX; 
  //     const shopActUrl = `${bucketPrefix}/${encodeURIComponent(fileName)}`;

  //     toast.success("Shop Act uploaded successfully!", {
  //       position: "top-right",
  //       autoClose: 3000,
  //     });

  //     // Pass firm name and Shop Act URL to parent
  //     onConfirm({ firmName: trimmedName, shopActUrl });

  //     // Reset
  //     setFirmName("");
  //     setShopActFile(null);
  //     onClose();
  //   } catch (error) {
  //     console.error("❌ Upload failed:", error);
  //     errorTost("Failed to upload Shop Act. Please try again.");
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };
  const isValidFirmName = (name) => {
    // يسمح فقط بحروف + أرقام + مسافات + -
    const regex = /^[A-Za-z0-9\s-]+$/;
    return regex.test(name);
  };

  const handleSave = () => {
    const trimmedName = firmName.trim();

    if (trimmedName === "") {
      errorTost("Please enter a valid firm name.");
      return;
    }

    // ✅ New validation
    if (!isValidFirmName(trimmedName)) {
      errorTost("Only letters, numbers, spaces and '-' are allowed.");
      return;
    }

    if (!shopActFile) {
      errorTost("Please select the Shop Act document.");
      return;
    }

    onConfirm({ firmName: trimmedName, shopActFile });

    setFirmName("");
    setShopActFile(null);
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          px: 8,
          py: 9,
          borderRadius: 2,
          minWidth: { xs: "85vw", sm: "500px" },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: { xs: "1.9rem", sm: "2rem" },
          fontWeight: 600,
        }}
      >
        PAN And RERA Name Mismatch — Please Enter Proprietorship / Firm Name
      </DialogTitle>

      <DialogContent>
        {/* Firm Name Input */}
        <TextField
          autoFocus
          margin="dense"
          label="Firm Name"
          fullWidth
          value={firmName}
          onChange={(e) => {
            const value = e.target.value;

            // Allow only valid characters while typing
            if (/^[A-Za-z0-9\s-]*$/.test(value)) {
              setFirmName(value);
            }
          }}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: { xs: "3rem", sm: "2.1rem" },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "3rem", sm: "1.25rem" },
            },
          }}
        />

        {/* File Selector */}
        <Button
          variant="outlined"
          component="label"
          sx={{
            mt: 2,
            fontSize: { xs: "2.8rem", sm: "1.5rem" },
          }}
          disabled={isUploading}
        >
          {shopActFile ? "Change ShopAct File" : "Upload ShopAct"}
          <input
            type="file"
            hidden
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={(e) => setShopActFile(e.target.files[0])}
          />
        </Button>

        {/* Show file name */}
        {shopActFile && (
          <p style={{ fontSize: "0.9rem", color: "green", marginTop: "5px" }}>
            Selected: {shopActFile.name}
          </p>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          sx={{ fontSize: { xs: "1.9rem", sm: "1.5rem" } }}
          disabled={isUploading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{ fontSize: { xs: "1.9rem", sm: "1.5rem" } }}
          disabled={isUploading}
        >
          {isUploading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}